import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { CreateEvaluationRequest } from '../models/requests/create-evaluation-request';
import { UpdateEvaluationRequest } from '../models/requests/update-evaluation-request';
import { Evaluation } from '../models/evaluation.model';

export interface UpdateEvaluationVigieRequest {
  potentialCause: string;
  correctiveAction: string;
}

@Injectable({
  providedIn: 'root',
})
export class EvaluationService {
  constructor(private apiService: ApiService) {}

  CreateEvaluation(payload: CreateEvaluationRequest): Observable<any> {
    return this.apiService.post(`/Evaluation/Create`, payload);
  }

  UpdateEvaluation(payload: UpdateEvaluationRequest): Observable<any> {
    return this.apiService.put(`/Evaluation/Update`, payload);
  }

  UpdateEvaluationVigie(
    uid: string,
    request: UpdateEvaluationVigieRequest,
  ): Observable<Evaluation> {
    return this.apiService.put<Evaluation>(
      `/Evaluation/${uid}/update-vigie`,
      request,
    );
  }

  public GetByRuleUid(ruleUid: string): Observable<Evaluation[]> {
    return this.apiService.get<Evaluation[]>(
      `/Evaluation/GetByRuleUidAsync/${ruleUid}`,
    );
  }
}
